import React from 'react'
import { IconProps } from '.'

export function CertifiedRepreveIcon({
  width = 50,
  height = 50,
}: IconProps): JSX.Element {
  return (
    <svg
      height={height}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      focusable='false'
      aria-hidden
      role='img'
    >
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h50v50H0z' fill='#fff' />
        <g fillRule='nonzero'>
          <path
            d='M22.953 26.387v10.629H19.34V13.272h5.367c2.565 0 4.45.21 5.916 1.335 1.44 1.126 2.278 2.985 2.278 5.21 0 3.822-1.86 5.995-5.446 6.413l9.294 12.278c3.69-3.168 6.073-7.88 6.073-13.142 0-9.58-7.749-17.33-17.33-17.33s-17.33 7.75-17.33 17.33c0 9.582 7.749 17.33 17.33 17.33a17.07 17.07 0 008.43-2.199L23.397 26.414h-.445z'
            fill='#221f1f'
          />
          <path
            d='M28.974 20.13c0-2.931-1.623-3.56-5.079-3.56h-.707v6.807h.707c3.377 0 5.079-.393 5.079-3.246'
            fill='#221f1f'
          />
          <path
            d='M43.764 5.812v2.513C39.157 3.115 32.64.183 25.597.183A24.38 24.38 0 005.518 10.76l-.235.34 2.408 1.676.236-.34c4.005-5.838 10.602-9.32 17.644-9.32 6.23 0 11.99 2.618 16.02 7.225h-2.486v2.932h7.565v-7.46zm-.759 31.492l-.235.34c-4.006 5.838-10.602 9.32-17.644 9.32-6.23 0-11.964-2.618-16.047-7.226h2.486v-2.932H4v7.461h2.932v-2.513c4.607 5.21 11.126 8.141 18.167 8.141A24.38 24.38 0 0045.178 39.32l.236-.34zm-.052 8.298c.707 0 1.256.55 1.256 1.23 0 .707-.55 1.23-1.256 1.23s-1.283-.549-1.283-1.23c0-.68.576-1.23 1.283-1.23zm-.026.262c-.55 0-.943.445-.943.995s.393.994.969.994c.55 0 .942-.445.942-.994 0-.55-.392-.995-.968-.995zm-.157 1.623h-.288v-1.23a1.95 1.95 0 01.47-.053c.236 0 .341.026.446.105.078.052.105.157.105.262 0 .157-.105.261-.262.288.13.052.183.13.235.314.027.183.053.262.079.288h-.314c-.053-.053-.053-.157-.105-.288-.026-.131-.105-.183-.262-.183h-.13v.497zm0-.707h.13c.158 0 .288-.052.288-.183 0-.105-.078-.183-.261-.183-.079 0-.131 0-.157.026z'
            fill='#76bc21'
          />
        </g>
      </g>
    </svg>
  )
}
